module.exports = __webpack_public_path__ + "img/14.6ff5d0ea.webp";